export enum EAnnouncementFieldType {
  TITLE = 'title',
  TEXT = 'text',
  MEDIA = 'media',
}
